import type { UserTableUI } from '@/domains/user/user.entity';

/**
 * Use Case para filtrar usuarios a nivel UI
 *
 * Responsabilidades:
 * - Filtrar por búsqueda textual (RUN, nombres, correo, rol)
 *
 * Principios SOLID aplicados:
 * - Single Responsibility: Solo se encarga del filtrado de usuarios
 * - Open/Closed: Fácilmente extensible para nuevos criterios de filtrado
 */
export class FilterUserUIUseCase {
  /**
   * Aplica filtro de búsqueda textual sobre múltiples campos
   * Busca coincidencias en RUN, nombres, correo y rol
   * @param users - Array de usuarios a filtrar
   * @param searchQuery - Texto de búsqueda (opcional, case-insensitive)
   */
  private applySearchFilter(
    users: UserTableUI[],
    searchQuery?: string,
  ): UserTableUI[] {
    if (!searchQuery || searchQuery.trim() === '') return users;

    const searchLower = searchQuery.toLowerCase();
    return users.filter((user) => {
      return (
        (user.run?.toLowerCase().includes(searchLower) ?? false) ||
        (user.nombres?.toLowerCase().includes(searchLower) ?? false) ||
        (user.mail?.toLowerCase().includes(searchLower) ?? false) ||
        (user.rol?.toLowerCase().includes(searchLower) ?? false)
      );
    });
  }

  /**
   * Ejecuta el filtrado de usuarios aplicando todos los filtros de UI
   * @param users - Array completo de usuarios a filtrar
   * @param searchQuery - Query de búsqueda textual
   */
  execute(users: UserTableUI[], searchQuery?: string): UserTableUI[] {
    if (!users || users.length === 0) return [];

    let filteredUsers = [...users];

    filteredUsers = this.applySearchFilter(filteredUsers, searchQuery);

    return filteredUsers;
  }
}
